import siteData from "../data/siteData.json";

function Contact() {
  const { company } = siteData;
  const [officeHours, phoneHour] = [
    company.workingHours.slice(0, 2),
    company.workingHours[2],
  ];

  return (
    <>
      <header>
        <div id="carouselExampleCaptions" className="carousel slide hm-slider">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={siteData.heroBanner} className="d-block w-100" alt="..." />
            </div>
          </div>
        </div>
      </header>
      <section className="page-title mt-2">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="about-head text-left">
                <h1>CONTACT US</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-page pb-5">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-6">
              <div className="row g-4">
                <div className="col-12">
                  <div className="contact-card">
                    <h3>
                      <i className="fa fa-envelope"></i> Send Us a Message
                    </h3>
                    <div className="success-message" id="successMessage">
                      <i className="fa fa-check-circle"></i> Thank you for your
                      inquiry! We will get back to you shortly.
                    </div>
                    <form className="contact-form" id="contactForm">
                      <div className="form-group">
                        <label htmlFor="name" className="required-field">
                          Full Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder="Enter your full name"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="phone" className="required-field">
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          className="form-control"
                          id="phone"
                          name="phone"
                          placeholder="Enter your phone number"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="email" className="required-field">
                          Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Enter your email address"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="query" className="required-field">
                          Your Query
                        </label>
                        <textarea
                          className="form-control"
                          id="query"
                          name="query"
                          placeholder="Tell us about your requirements..."
                          rows="4"
                          required
                        ></textarea>
                      </div>
                      <button type="submit" className="btn-submit">
                        <i className="fa fa-paper-plane"></i> Submit Inquiry
                      </button>
                    </form>
                  </div>
                </div>
                <div className="col-12">
                  <div className="contact-card">
                    <h3>
                      <i className="fa fa-phone"></i> Contact Info
                    </h3>
                    <div className="contact-info-item">
                      <i className="fa fa-phone"></i>
                      <div className="info-content">
                        <h5>Phone</h5>
                        <p>
                          <a href={company.phoneHref}>{company.phone}</a>
                        </p>
                      </div>
                    </div>
                    <div className="contact-info-item">
                      <i className="fa fa-envelope"></i>
                      <div className="info-content">
                        <h5>Email</h5>
                        <p>
                          <a href={`mailto:${company.email}`}>
                            {company.email}
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="row g-4">
                <div className="col-12">
                  <div className="contact-card">
                    <h3>
                      <i className="fa fa-building"></i> Our Office
                    </h3>
                    <img
                      src={company.officePhoto}
                      alt="Shree Mahavir Group Office"
                      className="office-photo"
                    />
                    <div className="contact-info-item">
                      <i className="fa fa-map-marker"></i>
                      <div className="info-content">
                        <h5>Address</h5>
                        <p>
                          {company.addressLines.map((line) => (
                            <span key={line}>
                              {line}
                              <br />
                            </span>
                          ))}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="contact-card">
                    <h3>
                      <i className="fa fa-clock"></i> Working Hours
                    </h3>
                    <div className="working-hours">
                      <h5>
                        <i className="fa fa-calendar"></i> Office Hours
                      </h5>
                      {officeHours.map((entry) => (
                        <div className="day" key={entry.label}>
                          <span>{entry.label}</span>
                          <span>{entry.time}</span>
                        </div>
                      ))}
                    </div>
                    <div className="working-hours mt-3">
                      <h5>
                        <i className="fa fa-phone"></i> Phone Hours
                      </h5>
                      <div className="day">
                        <span>{phoneHour.label}</span>
                        <span>{phoneHour.time}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-4 mt-4">
            <div className="col-12">
              <div className="contact-card">
                <h3>
                  <i className="fa fa-map"></i> Find Us
                </h3>
                <div className="map-container">
                  <iframe
                    src={company.mapEmbed}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Shree Mahavir Group Office Map"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;